import script from "./statistics.vue?vue&type=script&setup=true&lang=ts"
export * from "./statistics.vue?vue&type=script&setup=true&lang=ts"

import "./statistics.vue?vue&type=style&index=0&id=482d5285&lang=less&scoped=true"
import "./statistics.vue?vue&type=style&index=1&id=482d5285&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-482d5285"]])

export default __exports__